import axios from "axios";
import * as ActionType from "./admin.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";
import { secretKey } from "../../../util/config";

export const signupAdmin = (signup) => (dispatch) => {
  axios
    .post("admin/create", signup)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.SIGNUP_ADMIN });
        setToast("success", "Signup Successfully!");
        setTimeout(() => {
          window.location.href = "/admin-login";
        }, 3000);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
      console.log(error);
    });
};

export const updateCode = (signup) => (dispatch) => {
  axios
    .patch("admin/updateCode", signup)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Purchase Code Update Successfully !");
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

export const loginAdmin = (login, navigate) => (dispatch) => {
  axios
    .post("admin/login", login)
    .then((res) => {
      if (res.data.status && res.data.mfaRequired) {
        // Two-step is on for this account but this path has no code field.
        setToast("error", "This account needs a verification code. Please sign in again.");
      } else if (res.data.status && res.data.token) {
        dispatch({ type: ActionType.LOGIN_ADMIN, payload: res.data.token });

        setToast("success", "Login Successfully!");
        setTimeout(() => {
          navigate("/admin");
        }, 1500)
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

// get profile
export const getProfile = () => (dispatch) => {
  // Nobody logged in yet (the dashboard mounts briefly before the redirect to
  // the login page): don't ask the server for a profile it will refuse.
  const t = sessionStorage.getItem("token");
  if (!t || t === "null" || t === "undefined") return;
  apiInstanceFetch
    .get("admin/profile")
    .then((res) => {
      dispatch({ type: ActionType.PROFILE_ADMIN, payload: res.admin });
    })
    .catch((error) => {
      console.log("error", error);
    });
};

// Update Admin profile image

export const UpdateAdminImage = (formData) => (dispatch) => {
  axios
    .patch("admin/updateImage", formData, {
      headers: {
        key: `${secretKey}`,
        Authorization: `${sessionStorage.getItem("token")}`,
      }
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_IMAGE_PROFILE,
          payload: res.data.admin,
        });
        setToast("success", "Image Update Successfully");
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

export const updateProfile = (profileData) => (dispatch) => {
  
  apiInstanceFetch
    .patch("admin/updateProfile", profileData)
    .then((res) => {
      if (res.status === true) {
        dispatch({ type: ActionType.UPDATE_PROFILE, payload: res.admin });
        setToast("success", "Profile Update Successfully");
      } else {
        setToast(res.data.message);
      }
    })
    .catch(({ response }) => {
      console.log(response?.data);
    });
};

export const ChangeAdminPassword = (password) => (dispatch) => {
  apiInstanceFetch
    .patch("admin/updatePassword", password)
    .then((res) => {
      if (res.status === true) {
        setToast("success", "Your Password Changed Successfully !");
        dispatch({ type: ActionType.LOGOUT_ADMIN });
        setTimeout(() => {
          window.location.href = "/";
        }, [3000]);
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      setToast(error.message);
    });
};

export const forgotPassword = (data) => (dispatch) => {
  axios.post("admin/forgotPassword", data).then((res) => {
    if (res.data.status === true) {
      setToast("success", "Email Send Successfully !");
    } else {
      setToast("error", res.data.message);
    }
  });
};

export const resetPassword = (adminId, data, resetToken = "") => (dispatch) => {
  axios
    .post(`admin/setPassword?adminId=${adminId}&token=${encodeURIComponent(resetToken)}`, data)
    .then((res) => {
      if (res.data.status === true) {
        setToast("success", "Password Changed Successfully !");
        setTimeout(() => {
          dispatch({ type: ActionType.LOGOUT_ADMIN });
          window.location.href = "/";
        }, [100]);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast(error.message);
    });
};

// ==================== MFA Actions ====================

// Check if MFA is required for email
export const checkMFARequired = (email) => (dispatch) => {
  return axios
    .post("admin/mfa/check", { email })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.SET_MFA_REQUIRED,
          payload: res.data.requiresMFA,
        });
        return res.data.requiresMFA;
      }
      return false;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

// Verify TOTP during login
export const verifyLoginTOTP = (email, token, navigate, ticket = "") => (dispatch) => {
  axios
    .post("admin/mfa/verify", { email, token, ticket })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.LOGIN_ADMIN, payload: res.data.token });
        dispatch({ type: ActionType.CLEAR_MFA_DATA });
        setToast("success", "Login Successfully!");
        setTimeout(() => {
          navigate("/admin");
        }, 1500);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.message || "Verification failed");
    });
};

// Get MFA status for profile
export const getMFAStatus = () => (dispatch) => {
  apiInstanceFetch
    .get("admin/mfa/status")
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.SET_MFA_STATUS,
          payload: res.isMFAEnabled,
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Generate MFA secret and QR code
export const generateMFASecret = () => (dispatch) => {
  return apiInstanceFetch
    .get("admin/mfa/generate")
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.SET_MFA_QR_CODE,
          payload: { secret: res.secret, qrCode: res.qrCode },
        });
        return res;
      } else {
        setToast("error", res.message);
        return null;
      }
    })
    .catch((error) => {
      setToast("error", error.message || "Failed to generate MFA secret");
      return null;
    });
};

// Enable MFA
export const enableMFA = (token) => (dispatch) => {
  return apiInstanceFetch
    .post("admin/mfa/enable", { token })
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.SET_MFA_STATUS, payload: true });
        dispatch({ type: ActionType.CLEAR_MFA_DATA });
        setToast("success", "MFA enabled successfully!");
        return true;
      } else {
        setToast("error", res.message);
        return false;
      }
    })
    .catch((error) => {
      setToast("error", error.message || "Failed to enable MFA");
      return false;
    });
};

// Disable MFA
export const disableMFA = (token, password) => (dispatch) => {
  return apiInstanceFetch
    .post("admin/mfa/disable", { token, password })
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.SET_MFA_STATUS, payload: false });
        setToast("success", "MFA disabled successfully!");
        return true;
      } else {
        setToast("error", res.message);
        return false;
      }
    })
    .catch((error) => {
      setToast("error", error.message || "Failed to disable MFA");
      return false;
    });
};

// Clear MFA data
export const clearMFAData = () => (dispatch) => {
  dispatch({ type: ActionType.CLEAR_MFA_DATA });
};
